import { useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useStorage } from '@/js/libs/hooks/useStorage/index.ts';
import { StorageKey } from '../types.js';
export const useSelectedCompanyStorage = () => {
    const { loadJSON, loadNumber, removeItem, saveNumber, saveString } = useStorage({ storage: window.localStorage });
    const forgetSelectedCompany = useCallbackRef(() => {
        removeItem(StorageKey.SELECTED_COMPANY);
        removeItem(StorageKey.TEMPORARY_ACCESS_EXPIRES_AT);
    });
    // Drops a stored company that no longer parses, so the next start begins without a selection.
    const getSelectedCompany = useCallbackRef(() => loadJSON(StorageKey.SELECTED_COMPANY, () => removeItem(StorageKey.SELECTED_COMPANY)));
    const getTemporaryAccessExpiresAt = useCallbackRef(() => loadNumber(StorageKey.TEMPORARY_ACCESS_EXPIRES_AT));
    // Stores only the identifiers of the company, whatever else the given object carries.
    const storeSelectedCompany = useCallbackRef(({ id, companyUUID, name, temporaryAccessRequired }, temporaryAccessExpiresAt) => {
        saveString(StorageKey.SELECTED_COMPANY, JSON.stringify({ id, companyUUID, name, temporaryAccessRequired }));
        if (temporaryAccessExpiresAt) {
            saveNumber(StorageKey.TEMPORARY_ACCESS_EXPIRES_AT, temporaryAccessExpiresAt);
        }
        else {
            removeItem(StorageKey.TEMPORARY_ACCESS_EXPIRES_AT);
        }
    });
    return useMemo(() => ({
        forgetSelectedCompany,
        getSelectedCompany,
        getTemporaryAccessExpiresAt,
        storeSelectedCompany,
    }), [forgetSelectedCompany, getSelectedCompany, getTemporaryAccessExpiresAt, storeSelectedCompany]);
};
